import { useListTagsForAccountQuery } from "@generated";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";
import { useEffect, useState } from "react";
import { Tag } from "../types";
import { generated } from "@generated";
import { AppDispatch } from "@store/*";

const useGetAllAccountTags = () => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);
  const dispatch = useDispatch<AppDispatch>();
  const { data, isLoading, error } = useListTagsForAccountQuery({
    slug: accountSlug,
    page: {},
  });
  const [tags, setTags] = useState<Tag[]>([]);
  const [loading, setLoading] = useState(isLoading);

  useEffect(() => {
    if (!isLoading && data && data.data && data.meta && !error) {
      setTags(
        data.data.map((tag) => ({
          id: tag.id?.toString() || "",
          name: tag.attributes.name,
        }))
      );
      const pageCount = data.meta["page-count"] || 1;

      if (pageCount > 1) {
        setLoading(true);
        const fetchPages = async () => {
          try {
            for (let page = 2; page <= pageCount; page++) {
              // Trigger additional fetches for each page
              const resultAction = await dispatch(
                generated.endpoints.listTagsForAccount.initiate({
                  slug: accountSlug,
                  page: {
                    number: page,
                  },
                })
              ).unwrap(); // Assuming this is where the 'unwrap()' method is now chained

              // Check if resultAction.data exists and is an array before mapping
              if (resultAction.data && Array.isArray(resultAction.data)) {
                setTags((prevTags) => [
                  ...prevTags,
                  ...resultAction.data!.map((tag) => ({
                    id: tag.id?.toString() || "",
                    name: tag.attributes.name,
                  })),
                ]);
              }
            }
          } catch (err) {
            console.error("Failed to fetch additional pages:", err);
          } finally {
            setLoading(false);
          }
        };

        fetchPages();
      }
    }
  }, [data, isLoading, error, accountSlug, dispatch]);

  return { tags, loading, error };
};

export default useGetAllAccountTags;
